// extracted by mini-css-extract-plugin
export default {"cls1":"XGgNie_KZtEPYM5VGSMw","cls2":"wM7Wy83JrRolbSjIUJDU XGgNie_KZtEPYM5VGSMw"};